// Small shared helpers for the M2 rotary-era sim modules.
import { scriptedFlag } from '../data/news.js';
import { yf } from './defs.js';

// News flags: state.flags wins, else the scripted calendar (same rule as economy/market.js).
export function flagOn(state, flag) {
  const v = state.flags?.[flag];
  return v !== undefined ? !!v : !!scriptedFlag(flag, state.day);
}

export const isM2 = (state) => yf(state) >= 1901;
export const stats = (state) => state.company.stats;
export function bump(state, key, n = 1) {
  const s = state.company.stats;
  s[key] = (s[key] ?? 0) + n;
  return s[key];
}
